module.exports = __webpack_public_path__ + "static/img/loading.71303be5.gif";